import React from "react";
import SystemReports from "../superadmin/SystemReports";

function ViewerDashboardPage() {
  return <SystemReports />;
}

export default ViewerDashboardPage;
